import { useNavigate } from 'react-router-dom';
import { Box, Typography, Paper, Stack, Button } from '@mui/material';

const CompanyListPage = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
        企業ポータル
      </Typography>

      <Paper sx={{ p: 4 }}>
        <Stack direction="column" spacing={3}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Typography variant="h5" component="h2">
              企業登録
            </Typography>
          </Box>
          <Typography variant="body2">
            新しい企業をシステムに登録し、アカウントを管理できます。
          </Typography>
          <Button
            size="large"
            variant="contained"
            fullWidth
            onClick={() => navigate('/registration')}
            sx={{ borderRadius: 2 }}
          >
            企業登録へ
          </Button>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Typography variant="h5" component="h2">
              企業管理
            </Typography>
          </Box>
          <Typography variant="body2">
            企業に紐づいたプラン、キャンペーンの作成、管理を行うことができます。
          </Typography>
          <Button
            size="large"
            variant="contained"
            fullWidth
            onClick={() => navigate('/campaignlist')}
            sx={{ borderRadius: 2 }}
          >
            キャンペーン管理へ
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default CompanyListPage;
